import { dispatch } from '@wordpress/data';
import { PAYMENT_STORE_KEY } from '@woocommerce/block-data';
import { PAYONEER_STORE_KEY } from "./index";
import { select, subscribe } from '@wordpress/data';
import { paymentMethodName } from "../util/woocommerce";

export const setUpBlockCheckoutListeners = () => {

	let currentPaymentMethod;

	const wcPaymentStore = select( PAYMENT_STORE_KEY );
	const paymentStoreCallback = () => {
		const paymentMethod = wcPaymentStore.getActivePaymentMethod();
		if ( currentPaymentMethod !== paymentMethod ) {
			dispatch( PAYONEER_STORE_KEY ).setActivePaymentMethod( paymentMethod );
			currentPaymentMethod = paymentMethod;
		}
	}
	const unsubscribePaymentStore = subscribe( paymentStoreCallback, PAYMENT_STORE_KEY );
	paymentStoreCallback()

	return { unsubscribePaymentStore };
}

export const setupClassicCheckoutListeners = () => {
	const paymentMethodCallback = function () {
		const methodName = paymentMethodName()
		dispatch( PAYONEER_STORE_KEY ).setActivePaymentMethod( methodName );
	}
	jQuery( document.body ).on( 'payment_method_selected', paymentMethodCallback );
	paymentMethodCallback()
}


